import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top utility
export const scrollToTop = (smooth = true) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: smooth ? 'smooth' : 'auto'
  });
};

// Hook to scroll to top on route change
export const useScrollToTop = (smooth = true) => {
  const location = useLocation();

  useEffect(() => {
    scrollToTop(smooth);
  }, [location.pathname, smooth]);
};

// Hook to scroll to top when errors occur
export const useScrollToTopOnError = (error, smooth = true) => {
  useEffect(() => {
    if (error) {
      scrollToTop(smooth);
    }
  }, [error, smooth]);
};

// Hook for form errors - scrolls to top when form has errors
export const useFormErrorScroll = (errors, smooth = true) => {
  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      // Small delay to ensure error messages are rendered
      setTimeout(() => {
        scrollToTop(smooth);
      }, 100);
    }
  }, [errors, smooth]);
};
